import { render, staticRenderFns } from "./PsotAddEditProd.vue?vue&type=template&id=52df16d2&scoped=true&"
import script from "./PsotAddEditProd.vue?vue&type=script&lang=js&"
export * from "./PsotAddEditProd.vue?vue&type=script&lang=js&"
import style0 from "./PsotAddEditProd.vue?vue&type=style&index=0&id=52df16d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df16d2",
  null
  
)

export default component.exports